import { CustomerType } from 'store/modules/Customers/types';

export const prepareCustomerName = (customer: CustomerType) => {
  const cuttedName = customer.first_name.slice(0, 1);

  return `${cuttedName}.${customer.last_name}`;
};

export const calculateRiskSummary = (
  riskRequirement: any,
  riskTolerance: any,
  riskCapacity: any,
  recommendedRiskProfile: any,
  customers: Array<CustomerType>,
  hasRiskRequirementCapacityEnabled: boolean,
  riskToleranceCustomerTwo?: any
) => {
  const isMoreThanOneCustomer = customers && customers.length > 1;
  let data = [];
  if (isMoreThanOneCustomer) {
    const directCustomers = customers.filter(customer => !customer.is_jointed);
    const customerOne = directCustomers[0];
    const customerTwo = directCustomers[1];
    data = [
      {
        name: 'Risk requirement',
        value: riskRequirement ? riskRequirement.risk_requirement_level : 0
      },
      {
        name: `Risk tolerance ${prepareCustomerName(customerOne)}`,
        value: Number(riskTolerance) || 0
      },
      {
        name: `Risk tolerance ${prepareCustomerName(customerTwo)}`,
        value: Number(riskToleranceCustomerTwo) || 0
      },
      {
        name: 'Risk capacity',
        value: riskCapacity ? riskCapacity.risk_capacity_level : 0
      },
      {
        name: 'Recommended risk profile',
        value: Number(recommendedRiskProfile) || 0
      }
    ];
  } else {
    data = [
      {
        name: 'Risk requirement',
        value: riskRequirement ? riskRequirement.risk_requirement_level : 0
      },
      {
        name: 'Risk tolerance',
        value: Number(riskTolerance) || 0
      },
      {
        name: 'Risk capacity',
        value: riskCapacity ? riskCapacity.risk_capacity_level : 0
      },
      {
        name: 'Recommended risk profile',
        value: Number(recommendedRiskProfile) || 0
      }
    ];
  }

  if (hasRiskRequirementCapacityEnabled === false) {
    data = data.filter(
      value => !['Risk requirement', 'Risk capacity'].includes(value.name)
    );
  }

  return data;
};
